<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <div v-if="success">
      Congratulations, you are now subscribed to our service.<br ∕>You will be redirected to your subscription page in a few seconds.</br>
    </div>
    <div v-if="error">
      An error occurred during the subscription. Please try again.
    </div>
  </b-overlay>
</template>

<script>
import {BModal, BButton, BOverlay, BRow, BCol, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BModal,
    BButton,
    BRow,
    BCol
  },
  data() {
    return {
      subscriptions:[],
      subscription:null,
      success:false,
      error:false,
      pageLength: 3,
      totalRows:0,
      currentPage:1,
      dir: false,
      loading:true,
      selectedItem:null,
      columns: [
        {
          label: 'Code',
          field: 'code',
        },
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Amount',
          field: 'amount',
        },
        {
          label: 'Action',
          field: 'action',
        }
        
      ],
      rows: [],
      searchTerm: '',

    }
  },
  watch:{
    
  },
  methods:{
   
  },
  async mounted()
  {
    
    let checkout_session=await APIRequest.get_request('get-checkout-session/'+this.$route.params.id+'/'+this.$route.params.subscription_type_id+'/'+this.$route.params.user_id)

    if(checkout_session.data.status=="complete")
    {
      await APIRequest.create('subscriptions',{
        stripe_id:checkout_session.data.subscription,
        user:{id:this.$route.params.user_id},
        status:'active',
        customer_stripe_id:checkout_session.data.customer,
       
        subscription_type:{id:this.$route.params.subscription_type_id},
        date:new Date()
       
      })

      this.success=true

      setTimeout(() => {
        this.$router.push('/subscription')
      }, 3000)
    }
    else
    {
      this.error=true
    }
    // Initialize Checkout
    
 
    this.loading=false
  }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-good-table.scss';
.subscription-price
{
  font-size:30px;
}
.subscription-row {
  margin: 0 -10px;
}

.subscription-col {
  padding: 10px;
}
</style>
